import { Badge } from "@/components/ui/Badge";
import { useTranslation } from "react-i18next";
import { ButtonRing } from "@/components/brand/ButtonRing";
import type { ApprovalStatus, PiPaymentStatus } from "@/domain/types";
import { APPROVAL_TONE, PAYMENT_TONE, paymentProgress } from "@/domain/status";
import { translateStatus } from "@/domain/i18n";

/**
 * Payment status as a button being sewn on: the ring fills with the paid
 * fraction. The signature element, applied to its native use-case.
 */
export function PaymentStatusChip({
  status,
  paid,
  total,
  showRing = true,
}: {
  status: PiPaymentStatus;
  paid: number;
  total: number;
  showRing?: boolean;
}) {
  const { t } = useTranslation();
  const tone = PAYMENT_TONE[status];
  const label = translateStatus(t, status);
  const percent = Math.round(paymentProgress(paid, total) * 100);
  return (
    <span className="inline-flex items-center gap-1.5">
      {showRing && (
        <ButtonRing
          size={15}
          tone={tone === "neutral" ? "neutral" : tone}
          holes={2}
          progress={paymentProgress(paid, total)}
          title={t("status.paymentProgress", { status: label, percent })}
        />
      )}
      <Badge tone={tone}>{label}</Badge>
    </span>
  );
}

export function ApprovalChip({ status }: { status: ApprovalStatus }) {
  const { t } = useTranslation();
  return <Badge tone={APPROVAL_TONE[status]} outline>{translateStatus(t, status)}</Badge>;
}
